function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M891.93,167.49c-6.66,20.39-13.1,40.12-19.6,60.02c-286.69,0-573.07,0-860.15,0 c6.6-20.25,13.02-39.97,19.55-60.02C318.31,167.49,604.7,167.49,891.93,167.49z M374.1,196.5c0.28-0.03,0.56-0.05,0.83-0.08 c2.93,6.09,5.86,12.17,8.75,18.18c3.82,0,7.22,0,10.9,0c1.98-11.21,4.02-22.05,5.49-33.2c-3.76,0-6.65,0-9.52,0 c-1.86,5.93-1.77,11.9-3.92,18.55c-3.3-7.06-6.03-12.9-8.7-18.63c-3.92,0-7.34,0-11.33,0c-1.86,11.15-3.68,22.03-5.57,33.34 c3.65,0,6.54,0,9.78,0C371.94,208.42,373.02,202.46,374.1,196.5z M576.71,199.15c-0.18,6.99,3.18,12.54,9.42,15.02 c6.9,2.74,13.75,2.36,20.21-1.35c7.58-4.36,11.2-13.56,8.69-21.49c-2.22-7.02-9.52-11.41-18.29-11.01 C585.16,180.86,576.99,188.54,576.71,199.15z M410.74,181.34c-1.87,11.19-3.68,22.05-5.49,32.88c6.72,1.4,18.08,1.31,22.9-0.76 c3.09-1.33,6.33-3.27,8.41-5.83c8.09-9.93,2.51-24.39-10.08-26.18C421.62,180.76,416.58,181.34,410.74,181.34z M702.45,181.54 c-1.84,10.95-3.67,21.8-5.57,33.1c3.69,0,6.58,0,9.63,0c0.84-3.5,1.61-6.71,2.61-10.87c2.6,4.39,4.6,7.78,6.36,10.76 c3.78,0,6.96,0,10.81,0c-2.71-4.56-5.02-8.45-7.41-12.47c1.6-0.8,2.67-1.24,3.65-1.84c4.07-2.45,6.01-6.55,5.28-10.95 c-0.76-4.6-3.84-7.22-8.09-7.62C714.2,181.16,708.58,181.54,702.45,181.54z M225.83,202.22c1.32-0.66,2.05-1,2.75-1.39 c4.96-2.74,7.29-7.09,6.33-11.81c-0.87-4.3-4.28-7.33-9.82-7.77c-4.93-0.4-9.92-0.08-15.45-0.08c-1.87,11.15-3.69,22.05-5.6,33.45 c3.54,0,6.43,0,9.64,0c0.79-3.35,1.55-6.55,2.58-10.9c2.69,4.55,4.67,7.91,6.72,11.37c3.5-0.54,6.82,0.86,10.21-1.26 C230.75,209.96,228.45,206.34,225.83,202.22z M509.23,181.25c-1.04,6.11-2.03,11.67-2.93,17.24c-0.29,1.8-0.42,3.64-0.52,5.47 c-0.17,3.1,0.41,5.94,2.8,8.21c8.33,7.94,24.9,3.43,27.51-7.71c1.63-6.95,2.57-14.07,3.75-21.13c0.1-0.57-0.25-1.22-0.42-1.96 c-3.1,0-6,0-9.13,0c-0.53,2.77-0.98,5.21-1.47,7.64c-0.91,4.57-1.51,9.23-2.85,13.66c-1.5,4.96-5.27,5.66-10.26,1.69 c1.04-7.3,2.15-15.06,3.3-23.12C515.35,181.25,512.6,181.25,509.23,181.25z M499.06,214.69c-2.66-11.63-5.12-22.42-7.63-33.41 c-4.34,0-8.1,0-12.44,0c-5.7,10.75-11.49,21.66-17.7,33.36c4.21,0,7.28,0,10.47,0c1.3-1.84,2.63-3.71,4.15-5.88 c1.82,0,3.64-0.05,5.45,0.01c1.95,0.07,3.9,0.26,5.76,0.39c0.83,2.03,1.51,3.7,2.26,5.53C492.4,214.69,495.31,214.69,499.06,214.69z  M355.95,214.68c-2.57-11.42-5.03-22.32-7.52-33.38c-4.46,0-8.35,0-12.47,0c-5.83,10.95-11.56,21.71-17.71,33.28 c4.13,0,7.17,0,10.41,0c1.26-1.77,2.58-3.63,3.87-5.44c3.98,0,7.73,0,11.42,0c0.96,2.08,1.78,3.84,2.56,5.54 C349.57,214.68,352.32,214.68,355.95,214.68z M684.33,181.28c-4.42,0-8.32,0-12.44,0c-5.82,10.93-11.56,21.69-17.72,33.27 c4.26,0,7.44,0,10.56,0c1.32-1.94,2.52-3.7,3.69-5.4c4.01,0,7.76,0,11.43,0c0.98,2.09,1.8,3.84,2.59,5.54c3.06,0,5.82,0,9.41,0 C689.29,203.29,686.83,192.39,684.33,181.28z M269.59,209.72c5.73,6.2,13.52,7.74,20.5,4.51c4.13-1.91,6.49-5.09,6.83-9.65 c0.35-4.56-1.96-7.52-5.82-9.57c-2.13-1.13-4.15-2.46-6.23-3.71c2.4-3.6,2.4-3.6,9.81-0.75c1.18-1.97,2.41-4.02,3.53-5.89 c-4.28-5.34-13.71-5.31-17.85-2.69c-1.63,1.03-3.25,2.42-4.27,4.03c-3.18,5.02-1.53,10.18,3.86,13.47c2.43,1.48,5.74,1.99,6.77,5.59 c-4.78,4.64-8.45-0.03-12.6-1.57C272.57,205.6,271.14,207.57,269.59,209.72z M246.1,181.32c-1.55,11.44-4.39,22.11-5.08,33.33 c7.19,0,13.58,0,20.36,0c0.42-2.5,0.78-4.69,1.21-7.24c-3.77-0.33-6.97-0.61-10.59-0.93c0.47-1.75,0.79-2.95,1.13-4.19 c3.39-0.25,6.48-0.48,9.73-0.71c0.42-2.46,0.77-4.52,1.18-6.97c-3.53-0.35-6.54-0.65-10.06-1c0.67-1.86,1.08-3.01,1.47-4.1 c3.61-0.24,6.87-0.45,10.34-0.68c0.44-2.62,0.81-4.83,1.27-7.51C259.86,181.32,253.31,181.32,246.1,181.32z M748.04,189.57 c3.74-0.29,7.14-0.55,10.68-0.83c0.44-2.67,0.8-4.87,1.23-7.45c-7.27,0-13.83,0-20.94,0c-1.86,11.12-3.68,21.98-5.58,33.32 c7.46,0,13.98,0,21.03,0c0.24-2.55,0.44-4.73,0.67-7.19c-3.63-0.34-6.67-0.63-10.12-0.95c0.39-1.74,0.67-2.94,0.94-4.18 c3.44-0.24,6.53-0.46,9.8-0.7c0.39-2.47,0.71-4.54,1.1-7.04c-3.4-0.31-6.28-0.56-9.59-0.86 C747.57,192.06,747.8,190.86,748.04,189.57z M654.31,182.68c-8.01-3.28-15.42-3.51-22.53,0.6c-7.11,4.1-10.41,13.35-8,21.33 c2.24,7.43,8.55,11.55,17.43,11.18c2.45-0.1,4.88-0.65,7.7-1.05c0.49-2.96,0.93-5.62,1.38-8.35c-3.63,0.24-6.6,0.71-9.55,0.57 c-5.05-0.25-8.06-4.2-7.4-9.23c0.87-6.57,7.03-10.21,13.87-8.11c1.72,0.53,3.36,1.33,5.62,2.23 C653.35,188.61,653.81,185.77,654.31,182.68z M169.53,181.34c2.62,4.89,4.68,9.2,7.18,13.25c2.27,3.67,2.68,7.38,1.78,11.47 c-0.59,2.69-0.9,5.44-1.41,8.61c3.58,0,6.48,0,9.28,0c0.38-0.72,0.66-1.14,0.82-1.6c0.22-0.63,0.49-1.28,0.49-1.93 c0.07-8.76,4.5-15.42,10.27-21.45c0.8-0.84,1.53-1.76,2.24-2.68c1.26-1.63,2.47-3.3,4.28-5.71c-4.4,0-7.65,0-11.11,0 c-2.49,3.22-5.01,6.48-7.86,10.16c-1.83-3.63-3.44-6.85-5.09-10.12C176.97,181.34,173.75,181.34,169.53,181.34z M553.75,189.69 c-1.35,8.58-2.59,16.52-3.91,24.93c3.63,0,6.51,0,9.78,0c1.55-8.47,3.06-16.71,4.56-24.95c2.83-0.36,5.08-0.64,7.57-0.95 c0.35-2.53,0.65-4.74,1.03-7.49c-8.79-0.31-16.95-0.73-25.34,0.23c-0.42,2.65-0.77,4.85-1.16,7.31 C548.95,189.11,551.03,189.36,553.75,189.69z M155.59,214.62c1.57-8.5,3.09-16.75,4.6-24.92c2.87-0.36,5.12-0.64,7.55-0.95 c0.42-2.57,0.77-4.78,1.18-7.31c-8.87,0-17.05,0-25.49,0c-0.43,2.65-0.78,4.85-1.17,7.32c2.76,0.4,4.97,0.71,7.51,1.07 c-1.34,8.41-2.61,16.36-3.95,24.79C149.29,214.62,152.04,214.62,155.59,214.62z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M656.93,63.81c13.34,0,26.26,0,40.1,0c-8.73,28.41-17.29,56.28-25.95,84.45c-15.32,0-30.37,0-46.02,0 c-3.82-14.75-7.66-29.59-11.51-44.44c-0.3-0.01-0.6-0.02-0.9-0.03c-4.66,14.9-9.32,29.81-13.97,44.66c-13.26,0-25.86,0-39.44,0 c8.44-28.56,17.25-56.48,25.97-84.79c15.57-0.28,30.78-0.25,46.22-0.04c3.18,16.91,6.21,33.03,9.24,49.14 c0.35,0.05,0.7,0.11,1.05,0.16C646.78,96.61,651.83,80.29,656.93,63.81z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M108.06,63.49c0,0,6.2,32.98,9.28,49.24c0.35,0.07,0.7,0.15,1.05,0.22c5.04-16.3,15.35-49.47,15.35-49.47h39.85 c0,0-17.25,56.82-26,84.92c-15.36,0-30.29,0-45.82,0c-3.89-14.97-7.76-29.84-11.63-44.7c-0.29,0.02-0.57,0.04-0.86,0.06 c-4.62,14.83-9.24,29.67-13.88,44.57c-13.27,0-26.01,0-39.59,0c8.7-28.31,26.11-84.84,26.11-84.84H108.06z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M804.5,148.33c-13.36,0-26.1,0-39.29,0c-0.18-2.24-0.36-4.18-0.48-6.12c-0.11-1.79-0.17-3.58-0.28-5.79 c-11.28,0-22.17,0-33.46,0c-2.69,3.83-5.55,7.9-8.36,11.91c-14.95,0-29.66,0-45.43,0c19.79-28.76,39.08-56.79,58.38-84.84 c23.04,0,45.77,0,68.91,0C804.5,91.8,804.5,119.82,804.5,148.33z M765.87,84.87c-0.41-0.14-0.83-0.27-1.24-0.41 c-6.97,11.56-13.93,23.13-21.36,35.45c8.17,0,15.2,0,22.6,0C765.87,107.98,765.87,96.42,765.87,84.87z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M213.82,63.49c23.15,0,45.75,0,68.82,0c0,28.32,0,56.35,0,84.79c-13.17,0-26.04,0-39.28,0 c-0.22-4.01-0.42-7.75-0.64-11.89c-11.35,0-22.25,0-33.56,0c-2.58,3.78-5.29,7.73-8.18,11.95c-14.84,0-29.72,0-45.52,0 C175.19,119.64,194.58,91.46,213.82,63.49z M221.82,119.82c7.96,0,14.99,0,22.49,0c-0.06-11.96,0.13-23.44-0.77-35.08 C235.91,96.14,228.6,107.47,221.82,119.82z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M514.57,60.51c9.54,0.43,18.03,1.65,26.04,5.39c19.53,9.13,26.93,28.82,17.95,48.38 c-6.45,14.04-17.33,23.84-30.76,30.91c-18.63,9.81-38.25,13.47-58.8,7.39c-5.6-1.66-11.18-4.59-15.78-8.2 c-12.53-9.83-15.96-25.26-9.84-40.52c4.27-10.65,11.47-19.01,20.53-25.86C479.13,66.48,496.39,60.88,514.57,60.51z M483.91,116.88 c0.27,1.77,0.49,3.76,0.89,5.71c2.31,11.19,11.53,14.93,21.03,8.57c10.82-7.25,17.98-24.56,15.44-37.33 c-2.29-11.49-11.76-15.39-21.25-8.56C489.36,92.96,485.19,104.08,483.91,116.88z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M392.59,63.49c-2.34,7.37-4.53,14.27-6.88,21.66c-8.92,0-17.52,0-26.47,0c-6.02,21.26-11.9,42.04-17.87,63.13 c-13.62,0-27.02,0-41.35,0c6.38-20.87,12.65-41.39,19.21-62.84c-9.87,0-18.92,0-29.14,0c3.05-7.91,5.69-14.77,8.45-21.95 C329.59,63.49,360.51,63.49,392.59,63.49z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st0",
  points: "839.79,63.49 881.09,63.49 861.72,129.38 901.96,129.38 895.36,148.45 813.48,148.45 "
});

var _ref11 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st0",
  points: "418.29,148.38 376.8,148.38 402.94,63.49 444.08,63.49 "
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M595.4,207.02c-4.99,0.05-8.22-3.01-8.31-7.86c-0.1-5.79,4.19-10.12,9.97-10.04c4.86,0.06,8.2,3.4,8.14,8.12 C605.12,202.79,600.93,206.97,595.4,207.02z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M416.64,206.55c0.98-5.9,1.87-11.26,2.74-16.48c4.49-1.32,7.49-0.8,9.17,1.8c2.18,3.39,1.93,7.07,0.02,10.41 C426.1,206.61,422.01,207.37,416.64,206.55z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M711.53,187.72c2.56,0.73,4.34,1.23,5.9,1.67c0.64,5.87-0.57,6.93-7.12,6.26 C710.67,193.32,711.02,191.02,711.53,187.72z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M217.35,195.28c0.37-2.14,0.75-4.32,1.26-7.22c2.21,0.44,4.1,0.81,5.74,1.14 C225.3,195.36,223.68,196.73,217.35,195.28z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M479.7,200.34c1.39-2.93,2.45-5.18,3.52-7.44c0.36,0.03,0.72,0.06,1.08,0.08c0.47,2.28,0.94,4.57,1.51,7.35 C483.72,200.34,482.1,200.34,479.7,200.34z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M342.86,200.41c-2.22,0-3.89,0-6.24,0c1.29-2.9,2.38-5.37,3.48-7.84c0.33-0.02,0.65-0.03,0.98-0.05 C341.63,194.99,342.19,197.46,342.86,200.41z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M677.93,200.51c-1.69,0-3.14,0-5.35,0c1.21-2.78,2.22-5.1,3.51-8.08C678.22,195.35,678.62,197.77,677.93,200.51 z"
});

var SvgNationalTyre = function SvgNationalTyre(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 910 240",
    style: {
      enableBackground: "new 0 0 910 240"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNationalTyre, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "NationalTyre.svg";
export { ForwardRef as ReactComponent };